export const API_RESPONSE_ERROR_MESSAGES: Record<number, string> = {
  400: "Bad request to the API",
  401: "Unauthenticated request to the API",
  403: "You have no authorization for this action",
  404: "Requested resource was not found.",
  405: "The used request method is not allowed.",
  422: "Form data is invalid. Please double check the form fields.",
};
